import { render } from "./ButtonEmail.vue?vue&type=template&id=cf849ba2&scoped=true"
import script from "./ButtonEmail.vue?vue&type=script&lang=js"
export * from "./ButtonEmail.vue?vue&type=script&lang=js"

import "./ButtonEmail.vue?vue&type=style&index=0&id=cf849ba2&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf849ba2"]])

export default __exports__